import React, {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import {userSelector} from '@ibibo/user-reducer';
import Layout from './Layout/Layout';
import GstInvoice from './GstInvoice/GstInvoice';
import SubmitGstInput from './SubmitGstInput/SubmitGstInput';
import TrackGstInputCredit from './TrackGstInputCredit/TrackGstInputCredit';
import {data} from './data';
import {useAnalyticService} from '@ibibo/analytics-provider';
import {redirectToSameWindowWithRefresh} from '../../../../utils/redirectWithCrId';

const GstInvoiceReport = () => {
  const userInfo = useSelector(userSelector);
  const is_sub_user = userInfo?.userInfo?.is_sub_user || false;
  const [menuSelect, setMenuSelect] = useState('gstCommissionInvoice');
  const [popupCount, setPopupCount] = useState(false);

  const {updateAnalyticDataStore, sendTrackingDataToSdk} = useAnalyticService();
  const loadPDTTrackingData = ({userData, walletInfo}) => {
    const {account_id, is_sub_user, uuid} = userData;

    const pdtTrackingData = {
      global: {
        payload: {
          campaign_details: {
            campaign_name: 'mypartner_direct',
            campaign_key: 'MYPARTNER',
          },
          event_tracking_context: {
            traffic_source: 'mypartner_direct',
            domain_country: 'india',
            domain_currency: 'INR',
            domain_language: 'eng',
            env: 'prod',
            bu: 'mypartner_core',
            organisation: 'MMT',
            funnel_source: 'mypartner_core',
            topic_name: 'mmt_core_mypartner_pdt_client_logging',
            producer: 'mypartner_core',
            template_id: 179775,
          },
          user_context: {
            user_type: is_sub_user ? 'Sub User' : 'Admin',
            agency_code: account_id?.value,
            profile_type: 'cta',
            uuid: uuid?.value || '',
            is_logged_in: true,
            logging_channel: null,
            wallet_bal: walletInfo?.tb,
          },
        },
      },
      pageLoad: {
        payload: {
          page_context: {
            lob: 'common',
            lob_category: 'common',
            page_title: null,
            page_name: 'gstreports',
            subpage_name: null,
            site_section: null,
            page_type: 'landing',
            percent_page_viewed: null,
            prev_page_name: null,
            travel_store: null,
            page_url: null,
            funnel_step: 'landing',
            page_state_journey: null,
            sub_lob: 'mypartner_core',
            pg_time_interval: null,
            platform: null,
          },
          coupon_details: null,
          cross_sell_details: null,
          addon_details: null,
          traveller_details_list: null,
          payment_details: null,
          campaign_details: null,
          event_detail: {
            event_name: 'page_entry',
            event_type: 'user_action',
            event_value: 'gstreports',
            components: null,
            client_travel_store_meta: null,
            interaction_type: null,
            booking_info: null,
          },
        },
      },
    };
    if (pdtTrackingData) {
      updateAnalyticDataStore?.(pdtTrackingData, 'GST_INVOICE_REPORT');
      sendTrackingDataToSdk?.(pdtTrackingData, 'GST_INVOICE_REPORT');
    }
  };


  useEffect(() => {
    redirectToSameWindowWithRefresh('/coreui/gst-report');
  }, []);
  useEffect(() => {
    if (userInfo) {
      loadPDTTrackingData({userData: userInfo?.userInfo, walletInfo: userInfo?.walletInfo});
    }
  }, [userInfo]);
  useEffect(() => {
    if (!userInfo?.userInfo?.pokus_permission_access && is_sub_user) {
      window.open('/agent/transactionreport/', '_self');
    }
  }, [is_sub_user]);

  /**
   *
   * @param {*} menuName
   * @returns
   */
  const onMenuSelect = menuName => {
    setMenuSelect(menuName);
  };

  const setMenuToTrackPage = () => {
    setMenuSelect('trackGSTInputCredit');
  };

  /**
   *
   */
  return (
    <Layout
      title={data[menuSelect].title}
      summary={data[menuSelect].summary}
      onMenuSelect={onMenuSelect}
      menuSelect={menuSelect}
      onlyGST={userInfo?.userInfo?.permissions?.onlyGST}
      sendTrackingDataToSdk={sendTrackingDataToSdk}
    >
      {menuSelect === 'gstCommissionInvoice' && (
        <GstInvoice
          setPopupCount={setPopupCount}
          popupCount={popupCount}
          sendTrackingDataToSdk={sendTrackingDataToSdk}
        />
      )}
      {menuSelect === 'submitGSTInput' && (
        <SubmitGstInput
          setMenuToTrackPage={setMenuToTrackPage}
          sendTrackingDataToSdk={sendTrackingDataToSdk}
        />
      )}
      {menuSelect === 'trackGSTInputCredit' && <TrackGstInputCredit />}
    </Layout>
  );
};

export default GstInvoiceReport;
